// extracted by mini-css-extract-plugin
export default {"container":"MessageClip_container__4d9HV","slider":"MessageClip_slider__Bp8wK","label":"MessageClip_label__AY57E","customLabel":"MessageClip_customLabel__AO7zo"};